var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSpeedChanger = function SvgSpeedChanger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19.248 4.752a10.2 10.2 0 0 0-6.498-2.975V4.19a.75.75 0 0 1-1.5 0V1.777c-2.135.156-4.23.977-5.948 2.464l1.784 1.784a.75.75 0 1 1-1.06 1.061L4.24 5.302a10.2 10.2 0 0 0-2.464 5.948H4a.75.75 0 0 1 0 1.5H1A.75.75 0 0 1 .25 12c0-3.006 1.147-6.014 3.441-8.309 4.59-4.588 12.029-4.588 16.617 0A11.72 11.72 0 0 1 23.75 12a.75.75 0 0 1-.75.75h-3a.75.75 0 0 1 0-1.5h2.223a10.2 10.2 0 0 0-2.975-6.498",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M17.927 7.133a.75.75 0 0 0-1.06-1.06l-3.785 3.784a2.4 2.4 0 1 0 1.06 1.06zM12 11.1a.9.9 0 1 0 0 1.8.9.9 0 0 0 0-1.8",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M19 16v6M16 19h6M2 19h5"
  })));
};
export default SvgSpeedChanger;